import React from 'react';
import { FiStar } from 'react-icons/fi';
import FadeInView from './FadeInView';

const ease = [0.22, 1, 0.36, 1];

const testimonials = [
  {
    name: "Sarah Johnson",
    location: "London, UK",
    rating: 5,
    text: "Andrea was absolutely fantastic during our Corfu airport transfer! He was punctual, professional, and showed us the most beautiful spots in northeastern Corfu on our way to the hotel. His local knowledge made our first impression of the island unforgettable.",
    service: "Airport Transfer"
  },
  {
    name: "Blake Richardson",
    location: "LA, USA",
    rating: 5,
    text: "Spiro became our personal chauffeur during our week in Corfu and made our family vacation extraordinary. He knew all the best beaches around Kassiopi, recommended amazing tavernas, and even took us to hidden spots only locals know. The kids absolutely loved exploring Corfu with him!",
    service: "Private Chauffeur"
  },
  {
    name: "Elena Muller",
    location: "Munich, Germany",
    rating: 5,
    text: "Our Corfu sightseeing tour was outstanding! Our driver was incredibly knowledgeable about the island's history and took stunning photos of us at Paleokastritsa Beach. Seeing Corfu's hidden gems with such a professional guide was the highlight of our Greek vacation.",
    service: "Sightseeing Tour"
  }
];

const TestimonialsSection = ({ imagesLoaded }) => {
  return (
    <section className="py-24 lg:py-32 bg-[#faf7f6]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <FadeInView
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease }}
          className="text-center mb-16"
        >
          <p className="text-[#ba1609] text-xs uppercase tracking-[0.4em] mb-4">Guest Experiences</p>
          <h2 className="text-3xl lg:text-5xl font-light text-[#1a1012]" style={{ fontFamily: "'Playfair Display', serif" }}>
            What Our <span className="italic">Guests Say</span>
          </h2>
        </FadeInView>

        <div className="grid md:grid-cols-3 gap-6 mb-16">
          {testimonials.map((t, i) => (
            <FadeInView
              key={t.name}
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: i * 0.03, ease }}
              className="bg-white border border-black/10 rounded-2xl p-8 shadow-sm hover:shadow-lg hover:border-[#ba1609]/30 transition-[color,background-color,border-color,box-shadow] duration-500 flex flex-col"
            >
              {/* Stars */}
              <div className="flex gap-1 mb-5">
                {[...Array(t.rating)].map((_, j) => (
                  <FiStar key={j} className="w-4 h-4 text-[#ba1609] fill-[#ba1609]" />
                ))}
              </div>

              {/* Quote */}
              <blockquote className="text-[#5b4d4f] text-sm leading-relaxed font-light mb-6 flex-grow italic">
                "{t.text}"
              </blockquote>

              {/* Author */}
              <div className="flex items-center justify-between pt-5 border-t border-black/10">
                <div>
                  <h4 className="text-[#1a1012] font-medium text-sm">{t.name}</h4>
                  <p className="text-[#5b4d4f] text-xs">{t.location}</p>
                </div>
                <span className="text-[10px] bg-[#fbeceb] text-[#ba1609] px-3 py-1 rounded-full border border-[#ba1609]/20">
                  {t.service}
                </span>
              </div>
            </FadeInView>
          ))}
        </div>

      </div>
    </section>
  );
};

export default TestimonialsSection;
